var gt = new Gettext({ domain : 'js'});